import { Route } from "react-router-dom";

import { CREATE_EXPENSE, EDIT_EXPENSE, VIEW_EXPENSE, VIEW_USER_STATEMENT } from "src/constants";
import { EXPENSE_ROUTES } from "src/pages/expense/constants";
import { SubcontractorReceipt } from "src/pages/subcontractors";
import { PurchaseInvoice } from "src/pages/vendor";
import { WorkDetails } from "src/pages/worker";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { AddEditExpense } from "./AddEditExpense.page";
import { Expenses } from "./Expenses.page";
import { SingleExpense } from "./SingleExpense.page";

/** Route tree for the expense module, mounted under `/expense`. */
export const expenseRoutes = (
  <Route path={EXPENSE_ROUTES.root}>
    <Route index element={<ProtectedRoute permissions={VIEW_EXPENSE} component={Expenses} />} />
    <Route path=":id" element={<ProtectedRoute permissions={VIEW_EXPENSE} component={SingleExpense} />} />
    <Route path="add" element={<ProtectedRoute permissions={CREATE_EXPENSE} component={AddEditExpense} />} />
    <Route path="edit/:expenseId" element={<ProtectedRoute permissions={EDIT_EXPENSE} component={AddEditExpense} />} />
    <Route path="worker/:workId" element={<ProtectedRoute permissions={VIEW_USER_STATEMENT} component={WorkDetails} />} />
    <Route
      path="vendor/:invoiceId"
      element={<ProtectedRoute permissions={VIEW_USER_STATEMENT} component={PurchaseInvoice} />}
    />
    <Route
      path="subcontractor/:paymentId"
      element={<ProtectedRoute permissions={VIEW_USER_STATEMENT} component={SubcontractorReceipt} />}
    />
  </Route>
);
